export const Find_ALL_PRODUCTLIST_REQUEST = "Find_ALL_PRODUCTLIST_REQUEST"
export const Find_ALL_PRODUCTLIST_SUCCESS = "Find_ALL_PRODUCTLIST_SUCCESS"
export const Find_ALL_PRODUCTLIST_FAIL = "Find_ALL_PRODUCTLIST_FAIL"

export const Find_ALL_OFFER_PRODUCTLIST_REQUEST = "Find_ALL_OFFER_PRODUCTLIST_REQUEST"
export const Find_ALL_OFFER_PRODUCTLIST_SUCCESS = "Find_ALL_OFFER_PRODUCTLIST_SUCCESS"
export const Find_ALL_OFFER_PRODUCTLIST_FAIL = "Find_ALL_OFFER_PRODUCTLIST_FAIL"